import React from "react";

const IsInternalContext = React.createContext({
  isInternal: "",
  setIsInternal: () => {},
});

export default IsInternalContext;
